import React from "react";
import { useNavigate, useParams } from "react-router-dom";
//mui material component
import { Box, Grid, Typography, Paper, Button, Tooltip, Card } from "@mui/material";
//icons
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import SettingsBackupRestoreTwoToneIcon from "@mui/icons-material/SettingsBackupRestoreTwoTone";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import { useTheme } from "@emotion/react";
import { siteFields } from "./field";
import { useAuth } from "../../services/auth";
import { useSite } from "./Provider";
import { useEffect } from "react";
import { useState } from "react";
import ModalBox from "../../ui/ModalBox";
import { convertUTCToLocal } from "../../utilities/functions";
import { LoadingSpinner } from "../../ui/LoadingSpinner";
import { Settings } from "@mui/icons-material";
import SettingsFields from "./SettingsFields";


const InfoSite = ({ reload, setreload }) => {
  let navigate = useNavigate();
  let theme = useTheme();
  const { id } = useParams();
  let { role } = useAuth();
  const [open, setOpen] = useState(false);
  const [openClone, setOpenClone] = useState(false);
  const [LoadingIcon, setLoadingIcon] = useState(false);
  const [openSettings, setopenSettings] = useState(false)
  const handleCloseClone = () => {
    setOpen(false);
    navigate(-1);
  };
  const {
    state: { selected: SiteInfo },
    resetCounter,
    fetchTicketPrintingFields,
    siteClone,
  } = useSite();

  const handleClose = () => {
    setOpen(false);
  };

  const getData = (data) => {
    switch (data) {
      case "subCompanyName":
        return SiteInfo.subCompany?.subCompanyName
          ? SiteInfo.subCompany?.subCompany
          : "";
      case "companyName":
        return SiteInfo.company?.companyName
          ? SiteInfo.company?.companyName
          : "";
      case "counterNo":
        return SiteInfo.counter?.counterNo !== null
          ? SiteInfo.counter?.counterNo
          : "";
      case "counterMaxvalue":
        return SiteInfo.counter?.counterMaxvalue
          ? SiteInfo.counter?.counterMaxvalue
          : "";

      case "counterRenwalTime":
        return SiteInfo.counter?.counterRenwalTime
          ? convertUTCToLocal(SiteInfo.counter?.counterRenwalTime)
          : "";
      default:
        break;
    }
  };
  const handleResetCounter = () => {
    setLoadingIcon(true);
    try {
      resetCounter(id);
      setLoadingIcon(false);
      setreload(!reload);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (id) fetchTicketPrintingFields(id);
  }, [id]);

  const handleSuccess = async () => {
    setOpenClone(true);
  };
  const handleClone = async () => {
    try {
      await siteClone(id);
      handleSuccess();
    } catch (error) {
      console.log(error, "error");
    }
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: theme.dimensions.padding,
        mt: theme.dimensions.mt,
        mb: theme.dimensions.mb,
        background: theme.color.PaperbgColor,
        width: "90%",
      }}
    >
      <Typography variant="Poster" component="h4" gutterBottom>
        Site Information
      </Typography>
      {!SiteInfo ? (
        <LoadingSpinner />
      ) : (
        <>
          <Grid container>
            {siteFields.map((f, index) => {
              if (f.editOnly) return [];
              return (
                <Grid
                  item
                  xs={2}
                  sm={4}
                  md={4}
                  mt={2}
                  key={index}
                  sx={{ fontSize: "14px" }}
                >
                  {f.label !== "Vat" && (
                    <>
                      <span style={{ color: theme.color.PaperlabelColor }}>
                        {f.label}:{" "}
                      </span>
                      <span>
                        {SiteInfo[f?.name] && SiteInfo[f?.name]}
                        {getData(f?.viewLabel2)}
                      </span>
                    </>
                  )}

                  {f?.icon && (
                    <Tooltip title="Reset Counter">
                      <span onClick={() => setOpen(true)}>
                        <SettingsBackupRestoreTwoToneIcon
                          color="action"
                          sx={{
                            fontSize: 20,
                            cursor: "pointer",
                            "&:hover": { color: `${theme.color.black}` },
                          }}
                        />
                      </span>
                    </Tooltip>
                  )}
                  {LoadingIcon && <span>Loading...</span>}
                  {f.name === "includedVat" &&
                    (SiteInfo.includedVat ? (
                      <>
                        {SiteInfo?.vat}%{" "}
                        <span style={{ color: "#4AA785" }}>
                          <FiberManualRecordIcon
                            fontSize="small"
                            sx={{ fontSize: 10, mr: 0.2 }}
                          />
                          Included
                        </span>
                      </>
                    ) : (
                      <>
                        {SiteInfo?.vat}%
                        <span style={{ color: "rgba(0, 0, 0, 0.4)" }}>
                          <FiberManualRecordIcon
                            fontSize="small"
                            sx={{ fontSize: 10, mr: 0.2 }}
                          />
                          No Included
                        </span>
                      </>
                    ))}
                  {f.name === "inHouse" &&
                    (SiteInfo.inHouse ? (
                      <span style={{ color: "#4AA785" }}>
                        <FiberManualRecordIcon
                          fontSize="small"
                          sx={{ fontSize: 10, mr: 0.2 }}
                        />
                        Active
                      </span>
                    ) : (
                      <span style={{ color: "rgba(0, 0, 0, 0.4)" }}>
                        <FiberManualRecordIcon
                          fontSize="small"
                          sx={{ fontSize: 10, mr: 0.2 }}
                        />
                        Inactive
                      </span>
                    ))}

                  {f.name === "odooJournalEntry" &&
                    (SiteInfo.odooJournalEntry ? (
                      <span style={{ color: "#4AA785" }}>
                        <FiberManualRecordIcon
                          fontSize="small"
                          sx={{ fontSize: 10, mr: 0.2 }}
                        />
                        Active
                      </span>
                    ) : (
                      <span style={{ color: "rgba(0, 0, 0, 0.4)" }}>
                        <FiberManualRecordIcon
                          fontSize="small"
                          sx={{ fontSize: 10, mr: 0.2 }}
                        />
                        Inactive
                      </span>
                    ))}
                  {f.name === "hasMultipleCurrencies" &&
                    (SiteInfo.hasMultipleCurrencies ? (
                      <span style={{ color: "#4AA785" }}>
                        <FiberManualRecordIcon
                          fontSize="small"
                          sx={{ fontSize: 10, mr: 0.2 }}
                        />
                        Active
                      </span>
                    ) : (
                      <span style={{ color: "rgba(0, 0, 0, 0.4)" }}>
                        <FiberManualRecordIcon
                          fontSize="small"
                          sx={{ fontSize: 10, mr: 0.2 }}
                        />
                        Inactive
                      </span>
                    ))}
                  {f.name === "siteIsActive" &&
                    (SiteInfo.isActive ? (
                      <span style={{ color: "#4AA785" }}>
                        <FiberManualRecordIcon
                          fontSize="small"
                          sx={{ fontSize: 10, mr: 0.2 }}
                        />
                        Active
                      </span>
                    ) : (
                      <span style={{ color: "rgba(0, 0, 0, 0.4)" }}>
                        <FiberManualRecordIcon
                          fontSize="small"
                          sx={{ fontSize: 10, mr: 0.2 }}
                        />
                        Inactive
                      </span>
                    ))}
                  {f.name === "payOnline" &&
                    (SiteInfo.payOnline ? (
                      <span style={{ color: "#4AA785" }}>
                        <FiberManualRecordIcon
                          fontSize="small"
                          sx={{ fontSize: 10, mr: 0.2 }}
                        />
                        Active
                      </span>
                    ) : (
                      <span style={{ color: "rgba(0, 0, 0, 0.4)" }}>
                        <FiberManualRecordIcon
                          fontSize="small"
                          sx={{ fontSize: 10, mr: 0.2 }}
                        />
                        Inactive
                      </span>
                    ))}
                  {f.name === "ccNumberRequired" &&
                    (SiteInfo.ccNumberRequired ? (
                      <span style={{ color: "#4AA785" }}>
                        <FiberManualRecordIcon
                          fontSize="small"
                          sx={{ fontSize: 10, mr: 0.2 }}
                        />
                        Active
                      </span>
                    ) : (
                      <span style={{ color: "rgba(0, 0, 0, 0.4)" }}>
                        <FiberManualRecordIcon
                          fontSize="small"
                          sx={{ fontSize: 10, mr: 0.2 }}
                        />
                        Inactive
                      </span>
                    ))}
                </Grid>
              );
            })}
          </Grid>
          <Grid container sx={{ pt: 1, fontSize: "14px", mb: 2 }}>
            <Grid
              sx={{ color: theme.color.PaperlabelColor }}
              item
              xs={2}
              sm={4}
              md={4}
              mt={2}
            >
              Fields to be printed:{" "}
              <Typography
                variant="Poster"
                component="span"
                sx={{
                  ml: 5,
                  color: "#000",
                  textDecoration: "underline",
                  cursor: "pointer",
                  p: 1,
                  borderRadius: 10,
                  "&:hover": { backgroundColor: theme.color.gray200 },
                }}
                onClick={() => navigate(`TicketPrintingFields`)}
              >
                Customize tickets
              </Typography>
            </Grid>
          </Grid>
          <Box
            sx={{
              border: "1px dashed grey",
              borderRadius: "8px",
              p: 2,
              mb: 2,

              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
            }}
          >
            {SettingsFields.map((field, index) => (
              <Box
                key={index}
                sx={{
                  color: theme.color.PaperlabelColor,
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  fontSize: "14px",
                }}
              >
                {field?.label}
                {field.switch ? (
                  SiteInfo?.[field.name] ? (
                    <span style={{ color: "#4AA785" }}>
                      <FiberManualRecordIcon
                        fontSize="small"
                        sx={{ fontSize: 10, mr: 0.2 }}
                      />
                      Active
                    </span>
                  ) : (
                    <span style={{ color: "rgba(0, 0, 0, 0.4)" }}>
                      <FiberManualRecordIcon
                        fontSize="small"
                        sx={{ fontSize: 10, mr: 0.2 }}
                      />
                      Inactive
                    </span>
                  )
                ) : (
                  <span style={{ color: "black", fontWeight: 500 }}>
                    {SiteInfo?.[field.name] || "—"}
                  </span>
                )}
              </Box>
            ))}

            <Button
              sx={{
                background: "white",
                color: theme.color.blackBackground,
                border: `1px solid ${theme.color.blackBackground}`,
                "&:hover": { background: "white" },
                whiteSpace: "nowrap",
              }}
              onClick={() => {
                setopenSettings(!openSettings);
                console.log(SiteInfo,"before open popup")
              }}
            >
              <Settings fontSize="medium" />
              Settings
            </Button>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "end" }} mr={2}>
            {(role === "Admin" || role === "Company") && (
              <>
                <Button
                  sx={{
                    background: "white",
                    color: theme.color.blackBackground,
                    border: `1px solid ${theme.color.blackBackground}`,
                    "&:hover": { background: `white` },
                    mr: "10px",
                  }}
                  onClick={handleClone}
                >
                  <FileCopyOutlinedIcon fontSize="medium" />
                  Clone
                </Button>
                <Button
                  onClick={() => navigate("edit")}
                  sx={{
                    background: theme.color.blackBackground,
                    color: "white",
                    "&:hover": { background: `${theme.color.black}` },
                  }}
                >
                  Edit
                </Button>
              </>
            )}
          </Box>

          <ModalBox
            open={open}
            handleClose={handleClose}
            handleOperation={handleResetCounter}
            operation="edit"
            text="Are you sure you want to reset counter?"
          />
          <ModalBox
            open={openClone}
            handleClose={handleCloseClone}
            text={`Clone Site has been completed successfully..`}
          />
          <ModalBox
            operation="settings"
            open={openSettings}
            handleClose={() => {
              setopenSettings(!openSettings);
            }}
            text={`these are site's settings`}
            height={"fit-content"}
            existRow={SiteInfo}
          />
        </>
      )}
    </Paper>
  );
};

export default InfoSite;
